import { c as _c } from "react/compiler-runtime";
import { Button } from '@/components/Atoms/Button/Button';
import { Dialog, useDialog } from '@/components/Molecules/Dialog/Dialog';
import { QrCode } from '@/components/Molecules/QrCode/QrCode';
import useTranslation from '@/hooks/useTranslation';
import cn from '@/utils/classNames';
import ShareIcon from '@bloomberg/web-icons-react/Share';
import type { ButtonHTMLAttributes } from 'react';
import { useEffect, useState } from 'react';
import styles from './ShareLinkButton.module.css';
export const ShareLinkButton = t0 => {
  const $ = _c(35);
  let className;
  let linkFetcher;
  let rest;
  let shares;
  let t1;
  if ($[0] !== t0) {
    ({
      linkFetcher,
      className,
      shares,
      shareTokenRequired: t1,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = linkFetcher;
    $[3] = rest;
    $[4] = shares;
    $[5] = t1;
  } else {
    className = $[1];
    linkFetcher = $[2];
    rest = $[3];
    shares = $[4];
    t1 = $[5];
  }
  const shareTokenRequired = t1 === undefined ? false : t1;
  const [domain, setDomain] = useState("https://www.bnef.com");
  const [link, setLink] = useState();
  const {
    t
  } = useTranslation("common");
  const dialog = useDialog();
  let t2;
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setDomain(window.location.origin);
    };
    t3 = [];
    $[6] = t2;
    $[7] = t3;
  } else {
    t2 = $[6];
    t3 = $[7];
  }
  useEffect(t2, t3);
  let copyContent = "";
  if (link) {
    copyContent = `${domain}${link}`;
  }
  let t4;
  if ($[8] !== className) {
    t4 = cn(styles.shareLinkWrapper, className);
    $[8] = className;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <ShareIcon />;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== dialog || $[12] !== linkFetcher) {
    t6 = async () => {
      const fetchedLink = await linkFetcher();
      setLink(fetchedLink);
      dialog.open();
    };
    $[11] = dialog;
    $[12] = linkFetcher;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t) {
    t7 = t("common:Actions.share");
    $[14] = t;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== rest || $[17] !== t6 || $[18] !== t7) {
    t8 = <Button className={styles.shareLinkButton} kind="tertiary" type="button" icon={t5} onClick={t6} {...rest}>{t7}</Button>;
    $[16] = rest;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t) {
    t9 = t("common:Actions.share");
    $[20] = t;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== copyContent || $[23] !== shareTokenRequired || $[24] !== shares || $[25] !== t) {
    t10 = !shareTokenRequired || shares > 0 ? <QrCode value={copyContent} /> : <p>{t("common:Modals.ShareHandler.noShares")}</p>;
    $[22] = copyContent;
    $[23] = shareTokenRequired;
    $[24] = shares;
    $[25] = t;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] !== dialog || $[28] !== t10 || $[29] !== t9) {
    t11 = <Dialog title={t9} {...dialog}>{t10}</Dialog>;
    $[27] = dialog;
    $[28] = t10;
    $[29] = t9;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  let t12;
  if ($[31] !== t11 || $[32] !== t4 || $[33] !== t8) {
    t12 = <div className={t4}>{t8}{t11}</div>;
    $[31] = t11;
    $[32] = t4;
    $[33] = t8;
    $[34] = t12;
  } else {
    t12 = $[34];
  }
  return t12;
};
interface IProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  linkFetcher: () => Promise<string>;
  shareTokenRequired?: boolean;
  shares?: number;
}